<template>
  <div class="flex flex-row flex-wrap flex-grow mt-2 font-display">
    <div class="w-full font-display text-gray-700">
     <h3 class="text-4xl font-bold">Atualizar Estico</h3>
     <small>
       <router-link :to="{ name: 'estico.index' }" exact>
         <span class="material-icons align-middle">
          keyboard_backspace
         </span>
         Visualizar todos
       </router-link>
     </small>
     <div class="flex flex-wrap">
       <div class="w-full lg:w-3/4  mt-5 px-2">
        <div class="shadow-2l bg-white rounded-lg">
          <ValidationObserver v-slot="{ handleSubmit }">
          <form action="" @submit.prevent="handleSubmit(doUpdateEstico)" class="p-0">
            <div class="flex flex-wrap p-4">
                <div class="w-full lg:w-1/2 xl:w-full p-2 font-display">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <ui-textbox
                      enforce-maxlength
                      help="Campo maximo é 240"
                      label="Descrição"
                      placeholder="Descrição que será exibida na hora do pagamento!"
                      :multi-line="true"
                      v-model="description"
                      :rows="6"
                      :maxlength="240"
                  ></ui-textbox>
                  <span v-if="errors.length" class="bg-red-100 block text-red-600 mb-5 ">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              <div class="w-full lg:w-1/2 xl:w-1/2 p-2">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <input-icon
                    :icon="{ name: 'purchase-tag' }"
                    id="price"
                    name="price"
                    type="text"
                    v-model="price"
                    v-currency
                    label="Preço:"
                  ></input-icon>
                <span v-if="errors.length" class="bg-red-100 block text-red-600 mb-5 ">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="w-full lg:w-1/2 xl:w-1/2 p-2">
                <input-icon
                  :icon="{ name: 'tag', type: 'solid' }"
                  id="shipping"
                  v-currency
                  name="shipping"
                  type="text"
                  v-model="cost"
                  label="Custo (opcional):"
                ></input-icon>
              </div>
              <div class="w-full lg:w-1/2 xl:w-1/2 p-2" >
                <input-icon v-if="!calcule_shipping"
                  :icon="{ name: 'truck', type: 'solid' }"
                  id="shipping"
                  name="shipping"
                  v-currency
                  v-model="shipping"
                  type="text"
                  label="Custo do Frete:"
                ></input-icon>
              </div>
              <div class="w-full lg:w-1/2 xl:w-1/2 p-2 font-display" >
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <label for="intermediary_id" class="mb-1 text-xs sm:text-sm tracking-wide text-gray-600">
                    Intermediador:
                  </label>
                  <div class="relative">
                    <select
                    v-model="intermediary"
                    placeholder="Selecione"
                    class="text-sm sm:text-base relative w-full border rounded placeholder-gray-400 focus:border-indigo-400 focus:outline-none py-4 pr-4 pl-4"
                    name="intermediary_id"
                    id="intermediary_id"
                    >
                    <option :value="inter.id" v-for="inter in intermediaries" :key="inter.id">{{ inter.name }}</option>
                    </select>
                  </div>
                  <span v-if="errors.length" class="bg-red-100 block text-red-600 mb-5 ">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="w-full mb-3">
                <!-- <ui-switch v-model="calcule_shipping">
                  Calcular Frete
                </ui-switch> -->
                <div class="text-right">
                  Total:
                  <span class="block font-bold text-2xl">
                    {{ total | toCurrency }}
                  </span>
                </div>
              </div>
              <div class="w-full text-center ">
                <button class="w-full text-lg py-4 px-6 lg:py-4 lg:px-6 ml-2 bg-indigo-500 transition-all ease-out duration-300 hover:bg-indigo-400 text-white block rounded-sm font-bold">
                  Atualizar estico
                </button>
              </div>
            </div>
          </form>
          </ValidationObserver>
        </div>
      </div>
     <div class="w-full lg:w-1/4 mt-5 px-2 ">
        <div class="text-left bg-gray-200 p-2">
          <span class="material-icons align-middle text-yellow-400">
            star_rate
          </span>
          <p class="align-middle inline-block">

            Crie seu link e comece a vender
          </p>
        </div>
        <div class="rounded-lg p-5 content-center">
          <img src="@/assets/img/web.png" alt="" class="mx-auto" width="350px">
        </div>
     </div>
     </div>
    </div>
  </div>
</template>

<script>
import { extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import { parse } from 'vue-currency-input'

// Override the default message.
extend('required', {
  ...required,
  message: 'Esse campo é obrigatório'
})
// @ is an alias to /src
export default {
  name: '',
  components: {
  },
  data () {
    return {
      calcule_shipping: false,
      description: '',
      shipping: '',
      price: '',
      cost: '',
      intermediary: '',
      intermediaries: null,
      options: {
        currency: 'BRL',
        distractionFree: false,
        valueAsInteger: false,
        autoDecimalMode: true
      }
    }
  },
  computed: {
    total () {
      const shipping = parse(this.shipping, this.options)
      const price = parse(this.price, this.options)
      return shipping + price
    }
  },
  mounted () {
    this.$store.dispatch('PAYMENT_METHODS').then((response) => {
      const data = response.data
      this.intermediaries = data.filter((value) => {
        if (value.settings) {
          return value
        }
      })
    })
    this.$store.dispatch('SHOW_ESTICO', this.$route.params.id).then((response) => {
      const data = response.data
      this.description = data.description
      this.intermediary = data.intermediary_id
      this.price = this.$options.filters.toCurrency(data.price)
      this.cost = this.$options.filters.toCurrency(data.cost_price)
      this.shipping = this.$options.filters.toCurrency(data.shipping_amount)
    })
  },
  methods: {
    doUpdateEstico () {
      const data = {
        description: this.description,
        shipping_amount: parse(this.shipping, this.options),
        price: parse(this.price, this.options),
        intermediary_id: this.intermediary,
        cost_price: parse(this.cost, this.options),
        calcule_shipping: this.calcule_shipping,
        param: this.$route.params.id
      }
      this.$store.dispatch('UPDATE_ESTICO', data).then(response => {
        this.$toasted.success('Estico atualizado com sucesso. Boas Vendas!', {
          position: 'bottom-center',
          duration: 5000,
          icon: 'check'
        })
        this.$router.push({ name: 'estico.index' })
      }).catch(error => {
        this.$toasted.error('Algo deu errado!' + error, {
          position: 'bottom-center',
          duration: 5000,
          icon: 'close'
        })
      })
    }
  }
}
</script>
